module.exports = {"532528101":"南沙镇","532528102":"新街镇","532528202":"牛角寨乡","532528203":"沙拉托乡","532528204":"嘎娘乡","532528205":"上新城乡","532528206":"小新街乡","532528207":"逢春岭乡","532528208":"大坪乡","532528209":"攀枝花乡","532528210":"黄茅岭乡","532528211":"黄草岭乡","532528212":"俄扎乡","532528213":"马街乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532528.json
// module id = 2441
// module chunks = 0